export const europeanCodes = [
  'AX',
  'AL',
  'AD',
  'AT',
  'BY',
  'BE',
  'BA',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FO',
  'FI',
  'FR',
  'DE',
  'GI',
  'GR',
  'GG',
  'HU',
  'IS',
  'IE',
  'IM',
  'IT',
  'JE',
  'XK',
  'LV',
  'LI',
  'LT',
  'LU',
  'MK',
  'MT',
  'MD',
  'MC',
  'ME',
  'NL',
  'NO',
  'PL',
  'PT',
  'RO',
  'RU',
  'SM',
  'RS',
  'CS',
  'SK',
  'SI',
  'ES',
  'SJ',
  'SE',
  'CH',
  'UA',
  'GB',
  'VA',
]

export const europeanNationalities = [
  'Åland Island',
  'Albanian',
  'Andorran',
  'Austrian',
  'Belarusian',
  'Belgian',
  'Bosnian or Herzegovinian',
  'Bulgarian',
  'Croatian',
  'Cypriot',
  'Czech',
  'Danish',
  'Estonian',
  'Faroese',
  'Finnish',
  'French',
  'German',
  'Gibraltar',
  'Greek, Hellenic',
  'Channel Island',
  'Vatican',
  'Hungarian, Magyar',
  'Icelandic',
  'Irish',
  'Manx',
  'Italian',
  'Channel Island',
  'Latvian',
  'Liechtenstein',
  'Lithuanian',
  'Luxembourg, Luxembourgish',
  'Macedonian',
  'Maltese',
  'Moldovan',
  'Monégasque, Monacan',
  'Montenegrin',
  'Dutch, Netherlandic',
  'Norwegian',
  'Polish',
  'Portuguese',
  'Romanian',
  'Russian',
  'Sammarinese',
  'Serbian',
  'Slovak',
  'Slovenian, Slovene',
  'Spanish',
  'Svalbard',
  'Swedish',
  'Swiss',
  'Ukrainian',
  'British, UK',
]
